import { CommaSeparator, LabelCoins, LabelGender, Username } from '@/components/custom';
import BannerUserInfosDeviceAccountsCount from './BannerUserInfosDeviceAccountsCount';
import BannerUserInfosWarning from './BannerUserInfosWarning';
import BannerUserInfosEmail from './BannerUserInfosEmail';
import BannerUserInfosBan from './BannerUserInfosBan';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils.ts';
import routes from '@/lib/routes';
import { TProps } from '.';

const BannerUserInfos = ({ user, hideEmail, className, usernameProps, countWarningReceived, enableClickToRedirectToProfile, useSingleCharGender, onClick }: TProps) => {

	const navigate = useNavigate();

	const handleOnClick = () => {
		user?._id &&
			enableClickToRedirectToProfile &&
			navigate(routes.nav.users.single.getHref(user._id));
		// execute function
		onClick?.(user);
	};

	if (!user) {
		return <></>;
	}

	return (
		<div
			onClick={handleOnClick}
			className={cn(
				'flex flex-col',
				'animate__animated animate__fadeIn',
				(enableClickToRedirectToProfile || onClick) && 'cursor-pointer hover:bg-neutral-50',
				className
			)}>
			<Username
				user={user}
				badgeSize={16}
				{...usernameProps} />
			{
				!hideEmail &&
				<BannerUserInfosEmail email={user.email} />
			}
			<div className={'flex items-center space-x-1'}>
				<LabelGender
					useSingleChar={useSingleCharGender}
					countryIso3={user.countryIso3}
					gender={user.gender} />
				<CommaSeparator />
				<LabelCoins
					coins={user.coins}
					diamondWallet={user.diamondWallet} />
				<BannerUserInfosDeviceAccountsCount user={user} />
				<BannerUserInfosWarning countWarningReceived={countWarningReceived} />
				<BannerUserInfosBan user={user} />
			</div>
		</div>
	);

};

export default BannerUserInfos;
